import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "27",
  height: "36",
  viewBox: "0 0 27 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M25.7806 17.1706C26.3691 17.567 26.3691 18.433 25.7806 18.8294L1.57062 35.1367C0.906393 35.5841 0.0119613 35.1081 0.0119614 34.3073L0.0119628 1.69275C0.0119628 0.891892 0.906397 0.415944 1.57062 0.863351L25.7806 17.1706Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }